// import axios from "axios";
import axiosInstance from "./axiosSetup";
import { setEntityCache } from "./cache";

type Entity = {
    id : number;
    name: string;
};

export type EntityMap = {
    [entityType: string]: Entity[];
}

export const getCache = async (): Promise<EntityMap> => {
    try {
        
        
        const response = await axiosInstance.get("/uploader/getentities");
        // console.log("my response is ", response.data)

        if(!response.data || typeof response.data !== "object"){
            throw new Error("Invalid response format");
        }

        const cacheData = response.data;
        setEntityCache(cacheData);

        return cacheData;
    }catch(error){
        console.log("error fetching entity cache",error);
        throw error;
    }

};


